import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryClientColumn } from '../constants/dictionary-client-columns.constant';

export const generateClientColumns = () => {

	

	return [
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].email,
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].document,
			dataIndex: 'rut',
			key: 'rut',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].phone,
			dataIndex: 'phone',
			key: 'phone',
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].status,
			dataIndex: 'auth',
			key: 'auth',
		},
	];
};
